export const errorMsg = (e) => {
  return e?.response?.data || { message: "Network not available " };
};
